import { HOUR } from 'constants/date'
import { PollCreate, Post } from '@wellesley/openapi'

export const DEFAULT_POLL_EXPIRES_IN = (12 * HOUR) / 1000
export const DEFAULT_POLL_MULTIPLE = false
export const DEFAULT_POLL_HIDE_TOTALS = false
export const DEFAULT_POLL_OPTIONS = ['', '']

export const convertPollToPollCreate = (feed?: Post): PollCreate => {
  const pollData = feed?.poll

  return {
    options: pollData?.options.map((v) => v.title) || DEFAULT_POLL_OPTIONS,
    expiresIn: DEFAULT_POLL_EXPIRES_IN,
    multiple: pollData?.multiple ?? DEFAULT_POLL_MULTIPLE,
    hideTotals: pollData?.hideTotals ?? DEFAULT_POLL_HIDE_TOTALS,
  }
}
